import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { Star, ArrowRight } from "lucide-react";
import { storage } from "@/lib/storage";
import { allTutorials, accentClass } from "@/data/tutorials";
import { BookmarkButton } from "@/components/Bookmark";

export const BookmarksPage = () => {
  const [bookmarks, setBookmarks] = useState([]);

  useEffect(() => {
    setBookmarks(storage.getBookmarks());
  }, []);

  const items = bookmarks
    .map((slug) => allTutorials.find((t) => t.slug === slug))
    .filter(Boolean);

  return (
    <div className="px-6 sm:px-10 lg:px-16 py-12 animate-fade-in">
      <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-muted-foreground">
        Saved for later
      </p>
      <h1 className="font-display font-black tracking-tighter text-4xl sm:text-5xl lg:text-6xl mt-2">
        Your bookmarks
        <span className="text-brut-yellow">.</span>
      </h1>

      {items.length === 0 ? (
        <div className="mt-10 brut-border brut-shadow bg-background p-10 text-center">
          <Star
            className="w-10 h-10 mx-auto text-muted-foreground"
            strokeWidth={2.5}
          />
          <p className="font-display font-extrabold text-2xl mt-4">
            No bookmarks yet.
          </p>
          <p className="text-sm text-muted-foreground mt-2 max-w-md mx-auto">
            Hit the ⭐ icon on any tutorial header to save it for quick access
            later.
          </p>
          <Link
            to="/"
            data-testid="bookmarks-empty-cta"
            className="inline-flex items-center gap-2 brut-border brut-shadow brut-hover bg-foreground text-background mt-6 px-5 py-3 font-bold text-sm uppercase tracking-wider"
          >
            Browse chapters <ArrowRight className="w-4 h-4" strokeWidth={3} />
          </Link>
        </div>
      ) : (
        <div className="grid sm:grid-cols-2 gap-4 mt-8">
          {items.map((t) => (
            <Link
              key={t.slug}
              to={`/tutorial/${t.slug}`}
              data-testid={`bookmark-item-${t.slug}`}
              className="brut-border brut-shadow brut-hover bg-background p-5 group block"
            >
              <div className="flex items-start justify-between gap-3">
                <div className="min-w-0">
                  <span
                    className={`inline-block font-mono text-[10px] uppercase tracking-widest px-2 py-0.5 brut-border ${
                      accentClass[t.chapterAccent]
                    }`}
                  >
                    {t.id} · {t.chapterTitle}
                  </span>
                  <p className="font-display font-extrabold text-xl mt-3 leading-tight">
                    {t.title}
                  </p>
                  {t.intro && (
                    <p className="text-sm text-muted-foreground mt-2 line-clamp-2">
                      {t.intro}
                    </p>
                  )}
                </div>
                <BookmarkButton slug={t.slug} size="sm" />
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
};
